import GeneralConfigurationSimpleForm from './SettingsSimpleForm'

export default GeneralConfigurationSimpleForm
